/* Strobepro firmware finder (vanilla JS, no libraries, ~2 KB min).
   Progressive enhancement: all rows are already in the HTML. This only toggles `hidden`.
   No fetch, no DOM injection above the fold -> no layout shift. Filter state syncs to the URL
   (?q=x3&camera=Canon) so staff can send customers a direct link. Page-local only: does not touch
   native site search or Rapid Search. */
(function () {
  var root = document.querySelector('[data-fw-root]');
  if (!root) return;
  var form = root.querySelector('[data-fw-form]');
  var q = root.querySelector('[data-fw-q]');
  var selects = Array.prototype.slice.call(root.querySelectorAll('[data-fw-filter]'));
  var cards = Array.prototype.slice.call(root.querySelectorAll('[data-fw-list] .fw-card'));
  var countEl = root.querySelector('[data-fw-count]');
  var emptyEl = root.querySelector('[data-fw-empty]');
  var total = cards.length;

  // normalise "XPro II-C", "xproii c", "X-Pro2" style input to the same key
  function norm(s) {
    return (s || '').toLowerCase().replace(/pro\s*2\b/g, 'proii').replace(/[\s\-_/().（）]+/g, '');
  }
  // Tokens: each word plus each run of up to 4 words, so "ad200 pro ii" and "ad200proii" both match.
  function tokens(raw) {
    var w = (raw || '').toLowerCase().split(/\s+/).filter(Boolean), out = [];
    for (var i = 0; i < w.length; i++) for (var j = i + 1; j <= Math.min(i + 4, w.length); j++) out.push(norm(w.slice(i, j).join('')));
    return out;
  }
  // "x3" should match X3-C and X3Pro but not X360: if the term ends in a digit, the next character must not be a digit.
  function hit(toks, term) {
    for (var i = 0; i < toks.length; i++) {
      var t = toks[i];
      if (t.indexOf(term) === 0 && !(/\d$/.test(term) && /\d/.test(t.charAt(term.length)))) return true;
    }
    return false;
  }
  var index = cards.map(function (c) {
    return { el: c, toks: tokens(c.getAttribute('data-search')), type: c.getAttribute('data-type'),
             camera: c.getAttribute('data-camera') || '', tool: c.getAttribute('data-tool') };
  });

  function apply(push) {
    var term = norm(q.value);
    var f = {};
    selects.forEach(function (s) { f[s.getAttribute('data-fw-filter')] = s.value; });
    var shown = 0;
    for (var i = 0; i < index.length; i++) {
      var r = index[i];
      var ok = (!term || hit(r.toks, term)) &&
               (!f.type || r.type === f.type) &&
               (!f.tool || r.tool === f.tool) &&
               (!f.camera || r.camera.split(', ').indexOf(f.camera) !== -1);
      r.el.hidden = !ok;
      if (ok) shown++;
    }
    countEl.textContent = shown === total ? total + ' firmware files' : 'Showing ' + shown + ' of ' + total;
    emptyEl.hidden = shown !== 0;
    if (push) syncUrl(f);
  }

  function syncUrl(f) {
    if (!window.history || !history.replaceState) return;
    var p = new URLSearchParams();
    if (q.value) p.set('q', q.value);
    Object.keys(f).forEach(function (k) { if (f[k]) p.set(k, f[k]); });
    var s = p.toString();
    history.replaceState(null, '', location.pathname + (s ? '?' + s : '') + location.hash);
  }

  function readUrl() {
    var p = new URLSearchParams(location.search);
    if (p.get('q')) q.value = p.get('q');
    selects.forEach(function (s) {
      var v = p.get(s.getAttribute('data-fw-filter'));
      if (v) s.value = v;
    });
  }

  var t;
  q.addEventListener('input', function () { clearTimeout(t); t = setTimeout(function () { apply(true); }, 120); });
  selects.forEach(function (s) { s.addEventListener('change', function () { apply(true); }); });
  form.addEventListener('reset', function () { setTimeout(function () { apply(true); }, 0); });

  // "Latest releases" and deep links (#fw-handle): clear filters so the target is visible, then open it
  function reveal(hash) {
    var el = hash && document.getElementById(hash.slice(1));
    if (!el || !el.classList.contains('fw-card')) return;
    if (el.hidden) { form.reset(); q.value = ''; apply(true); }
    var d = el.querySelector('details'); if (d) { d.open = true; var s = d.querySelector('summary'); if (s) s.setAttribute('aria-expanded', 'true'); }
  }
  window.addEventListener('hashchange', function () { reveal(location.hash); });

  // Keep aria-expanded in sync on every toggle (release notes, how-to, FAQ)
  Array.prototype.forEach.call(root.querySelectorAll('details'), function (d) {
    var s = d.querySelector('summary');
    d.addEventListener('toggle', function () { s.setAttribute('aria-expanded', d.open ? 'true' : 'false'); });
  });

  readUrl();
  apply(false);
  reveal(location.hash);
})();
